export enum LEAD_TYPE_PATHS {
    AllLeads = 'all-leads',
    HotLeads = 'hot-leads',
    WarmLeads = 'warm-leads',
    InterestedLeads = 'interested-leads',
  }